module.exports = __webpack_public_path__ + "static/media/team.edb82985.jpg";